'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherCalendar, FeatherDownload, FeatherLock, FeatherUser } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import type { ApuracaoAuditoriaEntry } from '../types';
import { formatarDataHora, formatarMoedaBR } from '../utils/apuracaoFormatters';
import { auditoriaAcaoConfig, modalidadeContratoLabel, modalidadePostalLabel } from '../utils/apuracaoStatusConfig';
interface ApuracaoAuditoriaTabProps {
  entries: ApuracaoAuditoriaEntry[];
  onExportar?: () => void;
}
const dotClassByVariant: Record<string, string> = {
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-700',
  error: 'bg-error-100 text-error-700',
  brand: 'bg-brand-100 text-brand-700',
  neutral: 'bg-neutral-100 text-neutral-700'
};
export function ApuracaoAuditoriaTab(t0) {
  const $ = _c(19);
  const {
    entries,
    onExportar
  } = t0;
  if (entries.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="bg-default-background flex flex-col items-center justify-center gap-2 rounded-[16px] border border-dashed border-neutral-200 px-6 py-12 text-center"><span className="text-body-bold font-body-bold text-default-font">Aguardando primeira ação</span><span className="text-body font-body text-subtext-color">A trilha de auditoria começa quando o primeiro evento é registrado.</span></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== entries || $[2] !== onExportar) {
    const ordenadas = [...entries].sort(_temp);
    t3 = "flex flex-col gap-4";
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center gap-2 text-sm text-neutral-600"><FeatherLock className="h-4 w-4 text-neutral-400" />Histórico imutável — não pode ser editado ou excluído</div>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== onExportar) {
      t6 = onExportar && <Button variant="neutral-secondary" size="small" icon={<FeatherDownload />} onClick={onExportar}>Exportar</Button>;
      $[8] = onExportar;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    if ($[10] !== t6) {
      t4 = <div className="bg-default-background flex items-center justify-between rounded-[12px] border border-solid border-neutral-200 px-4 py-3">{t5}{t6}</div>;
      $[10] = t6;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t1 = "border-l-2 border-neutral-200";
    t2 = ordenadas.map((entry, index) => {
      const config = auditoriaAcaoConfig[entry.acao];
      const Icon = config.icon;
      return <li key={entry.id} className={`relative ml-[-9px] pl-6 ${index === ordenadas.length - 1 ? "" : "pb-6"}`}><span className={`absolute top-0 left-0 flex h-4 w-4 items-center justify-center rounded-full border-2 border-white ${dotClassByVariant[config.variant] ?? dotClassByVariant.neutral}`}><Icon className="h-2.5 w-2.5" /></span><div className="flex flex-col gap-2 pl-2"><div className="flex flex-wrap items-center gap-2"><span className="text-body-bold font-body-bold text-default-font">{config.label}</span><span className="text-caption font-caption text-subtext-color">·</span><span className="text-caption font-caption text-subtext-color flex items-center gap-1"><FeatherCalendar className="h-3 w-3" />{formatarDataHora(entry.timestamp)}</span></div><p className="text-body font-body text-neutral-700">{entry.descricao}</p><div className="text-caption font-caption text-subtext-color flex items-center gap-1.5"><FeatherUser className="h-3 w-3" />{entry.usuarioNome ?? "Sistema (autom\xE1tico)"}</div>{entry.acao === "CICLO_REABERTO" && <div className="border-warning-200 bg-warning-50 flex items-start gap-2 rounded-[8px] border px-3 py-2"><FeatherAlertTriangle className="text-warning-700 mt-0.5 h-4 w-4 shrink-0" /><span className="text-warning-800 text-xs">A fatura vinculada será reemitida no próximo fechamento deste ciclo.</span></div>}{entry.acao === "EVENTO_APURADO" && isRecord(entry.detalhes?.contractSnapshot) && <ContractSnapshotMini snapshot={entry.detalhes.contractSnapshot} />}{entry.acao !== "EVENTO_APURADO" && entry.detalhes && Object.keys(entry.detalhes).length > 0 && <div className="rounded-[8px] bg-neutral-50 px-3 py-2 text-xs text-neutral-700">{Object.entries(entry.detalhes).filter(_temp2).map(_temp3)}</div>}</div></li>;
    });
    $[1] = entries;
    $[2] = onExportar;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2) {
    t5 = <ol className={t1}>{t2}</ol>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp3(t0) {
  const [key_0, value] = t0;
  return <div key={key_0} className="flex gap-2"><span className="text-subtext-color font-medium">{key_0}:</span><span className="text-default-font">{String(value)}</span></div>;
}
function _temp2(t0) {
  const [key] = t0;
  return key !== "contractSnapshot";
}
function _temp(a, b) {
  return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
}
function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function ContractSnapshotMini(t0) {
  const $ = _c(20);
  const {
    snapshot
  } = t0;
  const modality = typeof snapshot.modality === "string" ? snapshot.modality : null;
  const postalModality = typeof snapshot.postalModality === "string" ? snapshot.postalModality : null;
  const unitPrice = typeof snapshot.unitPrice === "number" ? snapshot.unitPrice : null;
  const finalValue = typeof snapshot.finalValue === "number" ? snapshot.finalValue : null;
  const discountPercentage = typeof snapshot.discountPercentage === "number" ? snapshot.discountPercentage : null;
  const status = typeof snapshot.status === "string" ? snapshot.status : null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-brand-800 text-caption-bold font-caption-bold uppercase">Snapshot do contrato no momento do evento</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== status) {
    t2 = status && <div className="flex justify-between"><span className="text-brand-700">Status</span><span className="text-default-font font-medium">{status}</span></div>;
    $[1] = status;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== modality) {
    t3 = modality && <div className="flex justify-between"><span className="text-brand-700">Modalidade</span><span className="text-default-font font-medium">{modalidadeContratoLabel(modality) ?? modality}</span></div>;
    $[3] = modality;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== finalValue) {
    t4 = finalValue != null && <div className="flex justify-between"><span className="text-brand-700">Valor do contrato</span><span className="text-default-font font-medium">{formatarMoedaBR(finalValue)}</span></div>;
    $[5] = finalValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== unitPrice) {
    t5 = unitPrice != null && <div className="flex justify-between"><span className="text-brand-700">Valor unitário</span><span className="text-default-font font-medium">{formatarMoedaBR(unitPrice)}</span></div>;
    $[7] = unitPrice;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== discountPercentage) {
    t6 = discountPercentage != null && <div className="flex justify-between"><span className="text-brand-700">Desconto</span><span className="text-default-font font-medium">{discountPercentage}%</span></div>;
    $[9] = discountPercentage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== postalModality) {
    t7 = postalModality && <div className="flex justify-between"><span className="text-brand-700">Modalidade postal</span><span className="text-default-font font-medium">{modalidadePostalLabel(postalModality as never) ?? postalModality}</span></div>;
    $[11] = postalModality;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className="border-brand-100 bg-brand-50 flex flex-col gap-1 rounded-[8px] border px-3 py-2 text-xs">{t1}{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}